module.exports = __webpack_public_path__ + "static/Shelfie-676d174d164ece0f5a1e8fc1d8b39454.png";